// extracted by mini-css-extract-plugin
export default {"_":"ShiningFrame____zH5ng","halo":"ShiningFrame_halo__9bxl7","spinning_frame":"ShiningFrame_spinning_frame__yLAVJ"};